import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
import createPersistedState from 'vuex-persistedstate'

import common from './modules/common'
import userInfo from './modules/userInfo'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const persistedstateOptions = {
    storage: window.sessionStorage,
    key: 'brand-source'
}

export default new Vuex.Store({
    modules: {
        common,
        userInfo,
    },
    strict: debug,
    plugins: debug ? [createLogger(), createPersistedState(persistedstateOptions)] : [createPersistedState(persistedstateOptions)]
});
